import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CampaignModel from "../../models/campaign";

export default class CampaignRepository extends BaseRepository {
  static modelClass = CampaignModel;
  modelName = "campaign";
}
